import {
    fetchAllRates,
    fetchBestRates,
    SCENARIO_TYPES as MORTGAGE_SCENARIOS,
} from '@ratehub/mtg-common';

import {
    MORTGAGE_TERMS_ALL,
    BEST_MORTGAGE_SCENARIO_DEFAULT_PARAMS,
    ALL_MORTGAGE_SCENARIO_DEFAULT_PARAMS,
    MORTGAGE_TERMS,
} from '../definitions/MortgageTerms';

/**
 * Fetches mortgage rates from 'all' or 'best' endpoints depending on term
 * @param {object} params
 * @param {string} params.type fixed or variable mortgage
 * @param {string} params.term length of mortgage
 * @param {string} params.scenario scenario of mortgage (purchase, renewal, etc)
 * @param {string} params.province province code
 * @param {string} params.city city slug
 * @param {string} params.language language code
 */
export default async function fetchRatesForMortgageTable(params) {
    // If they're looking for term === "all", use the best rates API so they get the "best" of each type/term
    // SPECIAL CASE: HELOC doesn't have different type/term. This would result in only a single rate getting fetched. Use /all instead.
    if (params.term === MORTGAGE_TERMS_ALL && params.scenario !== MORTGAGE_SCENARIOS.HELOC) {
        // Build a NEW set of parameters.
        // NOTE: by using Object.assign, we're assuming we're dealing with flat objects.
        const combinedParams = Object.assign(
            {}, 
            BEST_MORTGAGE_SCENARIO_DEFAULT_PARAMS[params.scenario], 
            params,
        );

        // API expects type/term to be arrays
        combinedParams.term = MORTGAGE_TERMS;
        combinedParams.type = [ params.type ];

        delete combinedParams.scenario; // Don't need this for the query

        return fetchBestRates(params.scenario, combinedParams);
    }
    else {
        // Build a NEW set of parameters.
        // NOTE: by using Object.assign, we're assuming we're dealing with flat objects.
        const combinedParams = Object.assign(
            {},
            ALL_MORTGAGE_SCENARIO_DEFAULT_PARAMS[params.scenario], 
            params,
        );

        delete combinedParams.scenario; // Don't need this for the query

        return fetchAllRates(params.scenario, combinedParams);
    }
}
